import React from "react";

const PersonalInfoCard = ({profileData}) => {
  return (
    <div className="p-6 bg-white rounded shadow-lg w-1/4">
      {/* Heading */}
      <h2 className="text-lg font-bold text-gray-700">Personal Info</h2>      

      {/* User Profile */}
      <div className="mt-6 flex items-center">
        {/* User Image */}
        <img
          src={profileData.profileURL || "/Assets/default_user.png"}
          alt="User Profile"
          className="w-16 h-16 rounded-full object-cover"
        />
        {/* User Info */}
        <div className="ml-4">
          <h6 className="text-gray-500 font-bold text-lg flex items-center">
            {profileData.firstName} {profileData.lastName}
          </h6>
          <h6 className="text-gray-500 text-sm flex items-center">
            {profileData.cnic}
          </h6>
        </div>
      </div>

      {/* User Details */}
      <div className="mt-6">
        <h6 className="text-blue-600 font-semibold">Email:</h6>
        <span className="text-gray-500 text-sm">
          {profileData.email || "No email registered yet."}
        </span>

        <h6 className="text-blue-600 font-semibold mt-4">Phone:</h6>
        <span className="text-gray-500 text-sm">
          {profileData.cellPhone || "No phone number registered yet."}
        </span>

        <h6 className="text-blue-600 font-semibold mt-4">Location:</h6>
        <span className="text-gray-500 text-sm">
          {profileData.addressCity || "City"}, {profileData.countryOfBirth || "Country"}
        </span>
      </div>

      <div className="mt-20">
      <h2 className="text-lg font-bold text-gray-700">Education Details</h2>

        {/* <h6 className="text-blue-600 font-semibold mt-4">Degree</h6> */}
        <span className="text-gray-500 text-sm"><br/>{profileData.program}</span>
        <span className="text-gray-500 text-sm"><br/>{profileData.major}</span>
        <span className="text-gray-500 text-sm"><br/>{profileData.universityName}</span>
        <span className="text-gray-500 text-sm"><br/>{profileData.campusCity}</span>
        
        
      </div>
    </div>
  );
};

export default PersonalInfoCard;
